/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { useTheme } from "@mui/material/styles";
import React from "react";
import { Box, Grid, Typography } from "@mui/material";

const Colors = () => {
  const theme = useTheme();

  const paletteEntries = Object.entries(theme.palette).filter(([, value]) => {
    return typeof value === "object" && value !== null;
  });

  return (
    <>
      <Typography variant="h2" gutterBottom>
        Colors
      </Typography>
      <Grid container spacing={2}>
        {paletteEntries.map(([colorKey, colorValue]) => {
          return (
            <Grid key={colorKey} size={12}>
              <Typography variant="h5" gutterBottom>
                {colorKey}
              </Typography>
              <Grid container spacing={2}>
                {Object.entries(colorValue).map((entry) => {
                  const [key, color] = entry;

                  if (typeof color !== "string") {
                    return null;
                  }

                  return (
                    <Grid
                      key={key}
                      size={{
                        xs: 12,
                        sm: 4,
                        md: 4
                      }}>
                      <Box
                        sx={{
                          bgcolor: color,
                          color: theme.palette.getContrastText(color),
                          p: 2,
                          borderRadius: 1,
                        }}
                      >
                        <Typography variant="body1">{key}</Typography>
                        <Typography variant="body2">{color}</Typography>
                      </Box>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

export default Colors;
